import { Navigate, useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import DemandeDevis from './DemandeDevis';
import Devis from './Devis';

/**
 * Demande de devis : l'entrée unique du parcours côté devis.
 *
 * Deux vues d'un même dossier. « Demandes » liste les demandes et leur
 * estimation ; « Devis » suit les devis validés et envoyés (relance, réponse du
 * client, signature). La seconde était une entrée à part de la barre latérale ;
 * elle vit désormais ici, derrière `?vue=devis`.
 */
const VUES = [
  { cle: 'demandes', label: 'Demandes' },
  { cle: 'devis', label: 'Devis' },
];

function DemandesEtDevis() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const vue = params.get('vue') === 'devis' ? 'devis' : 'demandes';

  return (
    <div className="dd-conteneur">
      <nav className="cal-onglets dd-onglets" aria-label="Demandes et devis">
        {VUES.map((v) => (
          <button
            key={v.cle}
            type="button"
            className={'cal-onglet' + (vue === v.cle ? ' cal-onglet-actif' : '')}
            aria-current={vue === v.cle ? 'page' : undefined}
            onClick={() => navigate(v.cle === 'devis' ? '/demande-de-devis?vue=devis' : '/demande-de-devis')}
          >
            {v.label}
          </button>
        ))}
      </nav>
      <div className="dd-corps">{vue === 'devis' ? <Devis /> : <DemandeDevis />}</div>
    </div>
  );
}

/** Ancienne adresse /devis : mène à la vue Devis, filtres (dossier d'où l'on vient) conservés. */
export function RedirectionVersDevis() {
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  params.set('vue', 'devis');
  return <Navigate to={`/demande-de-devis?${params.toString()}`} replace />;
}

export default DemandesEtDevis;
